import { Language } from 'src/app/util/lang';
import { ProviderItemInputs } from '../models/provider-item-inputs';
import { ProviderInput } from '../models/provider-input';
import { ProviderValidation } from '../models/provider-validation';

export function getKeyAndValueFromForm(formData: any): any[] {
  let result = [];
  for (const [key, value] of Object.entries(formData)) {
    result.push(new ProviderItemInputs(key.replace('input_', ''), value));
  }
  return result;
}

export function checkProviderValidations(providerInput: ProviderInput[], inputs: ProviderItemInputs[], currenLang: any): ProviderValidation {
  const items: ProviderItemInputs[] = [];
  const errors: ProviderItemInputs[] = [];
  for (let i = 0; i < providerInput.length; i++) {
    const { Id, Name, Format, MaxLength, MinLength, Required, ForRequest } = providerInput[i];
    let validId;
    let validValue;
    for (let j = 0; j < inputs.length; j++) {
      const { ProviderInputId, Value } = inputs[i];
      if (Id.toString() == ProviderInputId) {
        if (!ForRequest && Required && !Value) {
          const message = currenLang == 'en' ? `"${Name}" field is required` : (currenLang == 'hy' ?
            `<<${Name}>> դաշտը պարտադիր է` : `Поле "${Name}", обязательное для заполнения`);
          errors.push(new ProviderItemInputs(ProviderInputId, `${message}`));
          break;
        }

        if (!ForRequest && MinLength && Value.length < MinLength) {
          const message = currenLang == 'en' ? `"${Name}" minimal value is ${MinLength}` : (currenLang == 'hy' ?
            `<<${Name}>> նվազագույն արժեքն է ${MinLength}` : `"${Name}" минимальное значение ${MinLength}`);
          errors.push(new ProviderItemInputs(ProviderInputId, ` ${message}`));
          break;
        }

        if (!ForRequest && Format && providerInput[i].Keyboard != "dropdown" && checkFormat(Value, new RegExp(Format.toString()))) {
          const message = currenLang == "en" ? `"${Name}" incorrect data  ${MaxLength}` : (currenLang == 'hy' ?
            `<<${Name}>> սխալ տվյալներ  ${MaxLength}` : `"${Name}" неверные данные ${MaxLength}`);
          errors.push(new ProviderItemInputs(ProviderInputId, ` ${message} `));
          break;
        }
        validId = ProviderInputId;
        validValue = Value;
      }
    }
    items.push(new ProviderItemInputs(validId, validValue));
  }
  return new ProviderValidation(items, errors);
}

export function checkFormat(value: string, pattern: RegExp) {
  return !new RegExp(pattern).test(value);
}


export function getStatus(state: string): string {
  const currentLang = Language.getCurrentLang();
  let result: string;
  switch (state) {
    case '1':
      result = currentLang == 'en' ? 'New' : (currentLang == 'hy' ? 'Նոր' : 'Новая');
      break;
    case '2':
    case '3':
      result = currentLang == 'en' ? 'Processing' : (currentLang == 'hy' ? 'Մշակվում է' : 'Обрабатывается');
      break;
    case '4':
      result = currentLang == 'en' ? 'Payment Accepted' : (currentLang == 'hy' ? 'Վճարումը կատարված է' : 'Оплата завершена');
      break;
    case '5':
      result = currentLang == 'en' ? 'Payment Rejected' : (currentLang == 'hy' ? 'Վճարումը մերժված է' : 'Оплата откланена');
      result = 'Վճարումը մերժված է';
      break;
    default:
      result = currentLang == 'en' ? 'Processing' : (currentLang == 'hy' ? 'Մշակվում է' : 'Обрабатывается');
      break;
  }
  return result;
}

export function getDate(duration: number | null): Date {
  const date = new Date();
  const currentDay = date.getDate();
  let days = duration ? currentDay - duration : currentDay;
  return new Date(Date.UTC(date.getFullYear(), date.getMonth(), days, date.getHours(), date.getMinutes(), date.getSeconds()));
}


export function downloadPdf(pdfBase64, fileName) {
  const linkSource = `data:application/pdf;base64,${pdfBase64}`;
  const downloadLink = document.createElement('a');
  downloadLink.href = linkSource;
  downloadLink.download = fileName;
  downloadLink.click();
}

export function getRoute(routeName: string): string {
  const lang = Language.getCurrentLang();
  return `/${lang}/${routeName}`;
}

